var map = {
	"./ar/live/index.vue": [
		8569,
		8569
	],
	"./bn/live/index.vue": [
		4187,
		4187
	],
	"./en/live/index.vue": [
		2393,
		2393
	],
	"./fa/live/index.vue": [
		3225,
		3225
	],
	"./ur/live/index.vue": [
		6485,
		6485
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4927;
module.exports = webpackAsyncContext;